import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const updateGroupAction = createAsyncAction(
  '@chat/UPDATE_GROUP_REQUEST',
  '@chat/UPDATE_GROUP_SUCCESS',
  '@chat/UPDATE_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingUpdateGroup: true
})

const success = (state: ChatState, action: ActionType<typeof updateGroupAction.success>): ChatState => {
  const { updatedChatData } = action.payload
  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnUpdateGroup: true,
    isLoadingUpdateGroup: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingUpdateGroup: false,
  isErrorOnUpdateGroup: true
})

export const updateGroupHandle = { asyncAction: updateGroupAction, request, success, failure }
